import { Funcionalidades } from '@/config/funcionalidades';

const SucursalVirtualRoutes = [
  {
    path: '/Edicion-Certificados',
    component: () =>
      import(
        '@/pantallas/SucursalVirtual/EdicionCertificados/EdicionCertificadosPantalla.vue'
      ),
    meta: {
      description: 'Edición de Certificados',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.EdicionCertificados,
    },
  },
  {
    path: '/Contratos-SIGA',
    component: () =>
      import(
        '@/pantallas/SucursalVirtual/ContratosSiga/ContratosSigaPantalla.vue'
      ),
    meta: {
      description: 'Mantenedor de Contratos SIGA',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.MantenedorContratosSIGA,
    },
  },
  {
    path: '/contratos',
    component: () =>
      import('@/pantallas/SucursalVirtual/Contratos/ContratosPantalla.vue'),
    meta: {
      description: 'Contratos',
      requiresAuth: true,
      moduloCodigo: Funcionalidades.Contrato,
    },
  },
];

export default SucursalVirtualRoutes;
